module.exports = __webpack_public_path__ + "static/Muli-Bold-e004c490a841cb5a964dc1869e09a3a6.ttf";